import { HuskyProposal, IProps } from 'lib/types'
import './print.scss'
import ProgressIndicatorPdf from 'components/ProgressIndicator/ProgressIndicatorPdf'
import HuskyCardPdf from 'components/HuskyCard/HuskyCardPdf'
import HuskyIvoBlock from 'components/HuskyIvoBlock/HuskyIvoBlock'

const ProposalHuskyPdf = ({ proposals }: IProps) => {

    const huskyProposal: HuskyProposal = proposals?.calculationData?.data?.huskyProposal;

    return (
        <div className="xsd-proposals-pdf print-page-break px-10 pt-10 row">
            <div className="col-12 msds-text-header-2 msds-text-display-3 msds-text-dark-blue pb-5">Recommended solution</div>
            <div className="col-4 mb-4">
                <ProgressIndicatorPdf
                    headline="Total storage"
                    inputName="Required/Available"
                    initialValue={huskyProposal?.storageWithOverhead?.value}
                    max={huskyProposal?.storageWithOverhead?.rangeMax}
                    unitType={huskyProposal?.storageWithOverhead?.unitType}
                />
            </div>

            <div className="col-4 mb-4">
                <ProgressIndicatorPdf
                    headline={"Storage per server: " + proposals?.calculationData?.data?.liveDatabase?.raidType}
                    additionalHeadlineInfo={huskyProposal?.diskUtilization?.additionalHeadlineInfo}
                    inputName="Required/Available"
                    initialValue={huskyProposal?.diskUtilization?.value}
                    max={huskyProposal?.diskUtilization?.rangeMax}
                    unitType={huskyProposal?.diskUtilization?.unitType}
                />
            </div>

            <div className="col-4 mb-4">
                <ProgressIndicatorPdf
                    headline="System utilization"
                    inputName="Load %"
                    initialValue={huskyProposal?.systemUtilization?.value}
                    max={huskyProposal?.systemUtilization?.rangeMax}
                    unitType={huskyProposal?.systemUtilization?.unitType}
                />
            </div>

            <div className="col-4 mb-4">
                <HuskyCardPdf headline="Camera streams" label="Per server" value={huskyProposal?.cameraStreams} />
            </div>

            <div className="col-4 mb-4">
                <HuskyCardPdf headline="Camera data rate" label="Per server" value={huskyProposal?.cameraDataRate} />
            </div>

            <div className="col-4 mb-4">
                <HuskyCardPdf headline="Smart client data rate" label="Per server" value={huskyProposal?.clientDataRate} />
            </div>

            <div className="col-12 pb-6 mb-4">
                <HuskyIvoBlock proposals={proposals} />
            </div>            
        </div>
    )
}

export default ProposalHuskyPdf
